'use client';
import { useEffect, useState } from 'react';
import AmplienceDynamicComponent from 'components/amplience/dynamic-component';
import { AmplienceFooterProps } from 'components/amplience/footer';
import { AmplienceMegaNavProps } from 'components/amplience/header-nav/components/mega-nav';
import GTMPageViewTracker from 'components/analytics/gtm-page-view-tracker';
import { sdk } from 'sdk';
import useAmplience from 'frontastic/hooks/useAmplience';
import Footer from '../footer';
import Header from '../header';

const NotFound = () => {
  sdk.defaultConfigure('en');

  const [isMounted, setIsMounted] = useState<boolean>(false);
  const { getContentByDeliveryKey } = useAmplience();
  const [referrer, setReferrer] = useState<string>();
  const [amplienceContent, setAmplienceContent] = useState(undefined);
  const [megaNavData, setMegaNavData] = useState<AmplienceMegaNavProps[] | undefined>(undefined);
  const [footerNavData, setFooterNavData] = useState<AmplienceFooterProps | undefined>(undefined);

  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  useEffect(() => {
    async function headerNav() {
      const res = await getContentByDeliveryKey('header-nav');
      setMegaNavData(res.amplienceContent?.megaNavs);
    }

    async function getFooterNavData() {
      const res = await getContentByDeliveryKey('footer');
      setFooterNavData(res.amplienceContent);
    }
    async function getContent() {
      const res = await getContentByDeliveryKey('not-found');

      setAmplienceContent(res.amplienceContent);
    }

    if (isMounted) {
      setReferrer(
        decodeURIComponent(
          document.cookie
            .split('; ')
            .find((row) => row.startsWith('lastPath='))
            ?.split('=')[1] ?? '',
        ),
      );
      getContent();
      headerNav();
      getFooterNavData();
      setIsLoaded(true);
      window.history.replaceState({ shallow: true }, '', '/not-found');
    }
  }, [isMounted]);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isLoaded) {
    return <div className="h-0">loading</div>;
  }
  if (isLoaded) {
    if (amplienceContent && megaNavData && footerNavData) {
      return (
        <div data-theme="default">
          <GTMPageViewTracker pageTypeVal="not-found" referer={referrer === '/not-found' ? '' : (referrer ?? '')} />
          <div>
            <Header dataSource={{ dataSource: { megaNavs: megaNavData as any } }} />
          </div>

          <div className="block min-h-[calc(100vh-96px)] px-4 md:block lg:mx-auto lg:block lg:min-h-[calc(100vh-187px)] lg:max-w-[--page-max-width]">
            <AmplienceDynamicComponent data={amplienceContent} />
          </div>
          <Footer
            data={{
              megaNav: footerNavData.megaNav,
              newsletterCopy: footerNavData.newsletterCopy,
              siteIntegrityGroup: footerNavData.siteIntegrityGroup,
              socialsGroup: footerNavData.socialsGroup,
            }}
          />
        </div>
      );
    }
  }
  return null;
};

export default NotFound;
